import { render, staticRenderFns } from "./InstallShopify.vue?vue&type=template&id=9a605c48&scoped=true&"
import script from "./InstallShopify.vue?vue&type=script&lang=js&"
export * from "./InstallShopify.vue?vue&type=script&lang=js&"
import style0 from "./InstallShopify.vue?vue&type=style&index=0&id=9a605c48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a605c48",
  null
  
)

component.options.__file = "InstallShopify.vue"
export default component.exports